__turbopack_context__.v({
  "container": "Header-module__Af2_WG__container",
  "content": "Header-module__Af2_WG__content",
  "navigation": "Header-module__Af2_WG__navigation",
  "title": "Header-module__Af2_WG__title",
});
